export const useFirebaseFunctions = () => {
  // Call the processChatMessage HTTP function
  const processChatMessage = async (data: {
    message: string
    projectId: string
    userId: string
    timestamp?: string
  }) => {
    try {
      // Use the Firebase Functions HTTP endpoint
      const response = await fetch('https://us-central1-manufix-20dde.cloudfunctions.net/processChatMessageHttp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      })
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      return await response.json()
    } catch (error) {
      console.error('Error calling processChatMessage function:', error)
      throw error
    }
  }

  return {
    processChatMessage,
  }
}